import Header from "./Header";
import Footer from "./Footer";
import AdBanner from "../ads/AdBanner";
import AdAffiliate from "../ads/AdAffiliate";
import AdWideSkyScraper from "../ads/AdWideSkyScraper";
import AdSquare from "../ads/AdSquare";
// import AdRectangle from "../ads/AdRectangle";
import MorseBarcode from "../../components/common/MorseBarcode";
// import { SITE_CONFIG } from "../../config/siteConfig";
// import SiteVersion from "../common/SiteVersion";


const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-base-200 selection:bg-primary-500 selection:text-base-50"
      style={{
              backgroundImage: 'radial-gradient(circle, #fdfbf7 0.5px, transparent 0.5px), radial-gradient(circle, #fdfbf7 0.5px, transparent 0.5px)',
              backgroundPosition: '1px 0, 3px 1px',
              backgroundSize: '4px 2px',
    }}>
      <Header />
      
      <div className="container max-w-7xl mx-auto mb-4 px-8 max-[360px]:px-4 py-4 flex-grow flex gap-4">
        <MorseBarcode
          placement="left"
          scrollDirection="down"
        />
        <MorseBarcode
          placement="right"
          scrollDirection="up"
        />
        {/* <MorseBarcode
          orientation="vertical"   // vertical | horizontal
          position="fixed"         // fixed | sticky | relative
          placement="left"         // left | right | top | bottom
          scroll={true}            // スクロール有無
          scrollSpeed={30}         // 秒数（大きいほど遅い）
          scrollDirection="down"   // down | up（vertical時） / left | right（horizontal時）
          messageIndex={0}         // 未指定=ランダム
          color="#111111"          // 未指定=デフォルト色
        /> */}
        <aside className="hidden lg:block w-[160px] shrink-0">
          <div className="sticky top-4">
            <AdWideSkyScraper />
          </div>
        </aside>
        <main className="flex-1 min-w-0">
          <div className="container mx-auto mt-0 mb-4">
            <AdBanner />
          </div>
          <div className="container mx-auto mt-0 mb-4">
            <AdAffiliate />
          </div>
          {children}
          <div className="container mx-auto">
            <AdBanner />
          </div>
        </main>
        <aside className="hidden lg:block w-[300px] shrink-0">
          <div className="sticky top-4">
            {/* <section className="mb-4 p-4 bg-base-50 rounded-xl border border-primary-500">
              <img src={SITE_CONFIG.logo} alt={SITE_CONFIG.name} />
              <p className="text-xs font-bold text-primary-500 mb-2">{SITE_CONFIG.name} - <SiteVersion /></p>
              <p className="text-xs text-primary-500/70 leading-relaxed mb-3">{SITE_CONFIG.description}</p>
            </section> */}
            <AdSquare />
          </div>
        </aside>
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;